import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "神翻译合集", to: "/collections" },
  { label: "避雷区", to: "/avoid" },
  { label: "翻译对比", to: "/compare" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50 shadow-paper">
            <i className="ri-fire-fill" aria-hidden="true"></i>
          </span>
          <span className="font-label text-xl md:text-2xl tracking-wide text-foreground-950">
            炮渣<span className="text-primary-600">漫画网</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                pathname === l.to
                  ? "bg-secondary-100 text-secondary-900 font-medium"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-message-3-line" aria-hidden="true"></i>
            投稿吐槽
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-xl text-foreground-900 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-lg px-4 py-3 text-base ${
                  pathname === l.to ? "bg-secondary-100 text-secondary-900 font-medium" : "text-foreground-800"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-base font-medium whitespace-nowrap text-background-50"
            >
              <i className="ri-message-3-line" aria-hidden="true"></i>
              投稿吐槽
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}